import { createContext, useContext } from 'react';
import { useAtomValue } from 'jotai';
import { WhiteLabelLogos } from '@/helpers/whiteLabel/theme';
import { whiteLabelLogosAtom } from '@/store/whiteLabel';

/**
 * Logos of the sender workspace for the pages rendered on the server (signing, filling): they come with the page props through
 * this context, not through the jotai store - the store of the server is shared by all the requests.
 */
export const WhiteLabelLogosContext = createContext<WhiteLabelLogos>({});

/** The name of the product of the sender workspace instead of "DataDoc" (page titles); undefined - the default one */
export const WhiteLabelNameContext = createContext<string | undefined>(undefined);

export const useWhiteLabelName = () => useContext(WhiteLabelNameContext);

/** The logos of the workspace: from the page props, or (the CRM widgets, loaded in the browser) from the store */
const useWhiteLabelLogos = (): WhiteLabelLogos => {
  const fromPage = useContext(WhiteLabelLogosContext);
  const fromStore = useAtomValue(whiteLabelLogosAtom);
  return fromPage.logo || fromPage.favicon ? fromPage : fromStore;
};

export default useWhiteLabelLogos;
